import { MainContainer } from "../../component/container";
import Ed from '../../assets/image/ed.jpg'
import Ed1 from '../../assets/image/Ed1.gif'
import Sp3 from '../../assets/image/sp3.gif'
import BouncingIcon from "../../component/BouncingIcon";
import ICO from '../../assets/ico/charity.png'
import { Element, Link } from 'react-scroll';
import { useNavigate } from "react-router-dom";

export default function Education() {
    const navigate = useNavigate();

    return (
        <MainContainer>
            <div id='content' className="">
                <img src={Ed} alt="Ed" className='w-screen h-screen object-cover opacity-70' />

                <div className="w-full absolute top-1/2 left-0 transform -translate-y-1/2 2xl:px-80 xl:px-52 px-10">
                    <div className="bg-[#87ceeb] bg-opacity-70 p-4 rounded-full">
                        <h1 className="text-lg sm:text-4xl font-bold text-white text-center">Education.</h1>
                    </div>
                </div>


                <Link to="Scroll" smooth={true} duration={500}>
                    <BouncingIcon />
                </Link>
            </div>
            <Element name="Scroll" className="element"><div className='min-h-[2px]'></div></Element>

            <div className="2xl:px-80 xl:px-52 px-10 mt-24 flex flex-col gap-20">
                <div className="flex lg:flex-row flex-col gap-5 justify-between items-center">
                    <img src={Ed1} alt="Ed1" className='max-w-[600px] w-full' />
                    <div>
                        Our mission is to ensure that children of any neighborhood, especially orphans and less fortunate abandoned children are given a chance to become a positive, active and vital part of our society.  With this in mind, our vision is to contribute to the abolition of worldwide juvenile delinquency as well as different crimes that young people are involved in today.
                    </div>

                </div>
                <div className="flex flex-col justify-center items-center">
                    <span className="italic">"By securing our youth's safety and education, we will secure the future of this world we are living in."</span>

                    <span className="font-bold">The ACRFI Founder</span>
                </div>
                <div>
                    <div className="flex lg:flex-row flex-col items-center justify-center">
                        <img src={Sp3} alt="sp3" className="mr-4 w-full" style={{ maxHeight: '600px' }} />
                        <div>
                            <p>The children in school uniform ( Right hand side) are the group of our pionneer orphans we take complete care of, for the last 6 years.

                                They are orphans of both parents living either with some relatives or good samaritan families. We have lost some children along the way, dropping school and running away from those families for multiple reasons; but with your support, we manage to give those that remain, a hope for their future. "WE COULD NOT HAVE DONE IT WITHOUT THE SUPPORT OF OUR PARTNERS!"</p>
                        </div>
                    </div>
                    <div className="mt-1">How about the thousands that are still wondering in the streets of Congo, DRC? Would you join your effort to ours and save their lives?
                        Every year, the Founder, Co-founder or other members of our foundation, the ACRFI, travel to Congo and bring the collected supports, either monetary or goods to the orphans of the ACRFI-CONGO, and assess their progress in school, as well as their well-being.
                    </div>
                </div>

                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center text-blue-400 gap-3">Donate today and make a difference in their lives today! by clicking to this icon <img src={ICO} alt={'ICO'} sizes={40} className="cursor-pointer" /> </div>
                    <div>Or go to: <span className="text-blue-400 hover:underline cursor-pointer" onClick={() => { navigate('/Donate') }}>donate today</span> and choose your best way to give to the work of God!</div>
                </div>
            </div>
        </MainContainer>
    )
}